/** Подсветка Python по правилам A0: комментарии приглушённо курсивом,
 *  строки жёлтым, ключевые слова акцентом, числа синим, имена функций
 *  основным цветом жирным. Возвращает токены по строке. */
export type Token = { kind: "comment" | "string" | "keyword" | "number" | "func" | "plain"; text: string };

const KEYWORDS = new Set(
  "def class return import from as if else elif for while in not and or None True False lambda with try except raise pass assert print self".split(" "),
);
const RE = /(#.*$)|("""[\s\S]*?"""|'''[\s\S]*?'''|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')|\b(\d+\.?\d*)\b|([A-Za-z_]\w*)(?=\()|\b([A-Za-z_]\w*)\b/g;

export function highlightLine(line: string): Token[] {
  const out: Token[] = [];
  let last = 0;
  for (const m of line.matchAll(RE)) {
    const idx = m.index ?? 0;
    if (idx > last) out.push({ kind: "plain", text: line.slice(last, idx) });
    const [full, comment, str, num, fn, word] = m;
    if (comment) out.push({ kind: "comment", text: comment });
    else if (str) out.push({ kind: "string", text: str });
    else if (num) out.push({ kind: "number", text: num });
    else if (fn) out.push({ kind: KEYWORDS.has(fn) ? "keyword" : "func", text: fn });
    else if (word) out.push({ kind: KEYWORDS.has(word) ? "keyword" : "plain", text: word });
    else out.push({ kind: "plain", text: full });
    last = idx + full.length;
  }
  if (last < line.length) out.push({ kind: "plain", text: line.slice(last) });
  // Соседние plain-куски склеиваем: меньше span'ов, проще тесты.
  return out.reduce<Token[]>((acc, t) => {
    const prev = acc[acc.length - 1];
    if (prev && prev.kind === "plain" && t.kind === "plain") prev.text += t.text;
    else acc.push({ ...t });
    return acc;
  }, []);
}
